import FancyBets from './FancyBets';

export default FancyBets;